import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'components/DashboardNavbar';
import Footer from 'examples/Footer';
import DataTable from 'components/DataTablePage/components/DataTable';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';

const PAGE_ICONS = {
  Games: { icon: 'sports_esports', color: '#4fc3f7' },
  Players: { icon: 'people', color: '#81c784' },
  'Suspicious actions': { icon: 'gpp_bad', color: '#e57373' },
  Sessions: { icon: 'schedule', color: '#ffb74d' },
  Metrics: { icon: 'bar_chart', color: '#ce93d8' },
  Leaderboards: { icon: 'emoji_events', color: '#ffd54f' },
  Tournaments: { icon: 'military_tech', color: '#ff8a65' }
};

function DataTablePage({
  title,
  createButton = false,
  canFilter = false,
  filtersComponent = null,
  fetchData,
  queryKey,
  columnData,
  object,
  onDelete,
  onView,
  noActions = false,
  subrowFetchData = null,
  filters = {},
  showOnly
}) {
  const pageIcon = PAGE_ICONS[title];
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={{ xs: 2, md: 6 }} pb={{ xs: 1, md: 3 }}>
        <Card>
          <MDBox
            sx={{
              height: '3px',
              background: 'linear-gradient(90deg, #e2001b, #ff4f69, transparent 80%)',
              borderRadius: '12px 12px 0 0'
            }}
          />
          <MDBox p={{ xs: 1.5, md: 3 }} lineHeight={1} display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap' gap={1}>
            <MDBox display='flex' alignItems='center' gap={1.5}>
              {pageIcon && (
                <MDBox
                  sx={{
                    width: 38,
                    height: 38,
                    borderRadius: '10px',
                    background: `${pageIcon.color}18`,
                    border: `1px solid ${pageIcon.color}40`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                  }}
                >
                  <Icon sx={{ fontSize: '1.25rem', color: pageIcon.color }}>{pageIcon.icon}</Icon>
                </MDBox>
              )}
              <MDTypography variant='h5' fontWeight='medium'>
                {title}
              </MDTypography>
            </MDBox>
            {createButton ? createButton : null}
          </MDBox>
          <DataTable
            canFilter={canFilter}
            filtersComponent={filtersComponent}
            fetchData={fetchData}
            queryKey={queryKey}
            columnData={columnData}
            object={object}
            onDelete={onDelete}
            onView={onView}
            noActions={noActions}
            subrowFetchData={subrowFetchData}
            filters={filters}
            showOnly={showOnly}
          />
        </Card>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default DataTablePage;
